module.exports = __webpack_public_path__ + "media/images/build-89b23c8821469e253bf9aef695e1f141.gif";